import axios from "./userInstance"
import { Role } from "@/types/role"

export default async (page = 1, size = 100) => {
  try {
    const response = await axios(`/roles/`)
    return response.data
  } catch (error) {
    return [] as Role[]
  }
}
